import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Checkbox from '../Checkbox';

const SchoolApplicationSettingsForm = reduxForm({
  form: 'schoolApplicationSettings',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(({
  handleSubmit,
  submitting,
  onSubmit,
}) => (
  <form onSubmit={handleSubmit(onSubmit)}>
    <div className="w-checkbox">
      <Field
        label="Waitlist Enabled"
        component={Checkbox}
        name="waitlistEnabled"
        id="waitlistEnabled"
        className="w-checkbox-input"
      />
    </div>
    <div className="btn-padding">
      <input
        type="submit"
        value={submitting ? 'Please wait...' : 'Save Changes'}
        disabled={submitting}
        className="btn-solid-green w-button"
      />
    </div>
  </form>
));

function mapStateToProps(state, props) {
  const { waitlistEnabled } = props;

  return {
    initialValues: {
      waitlistEnabled,
    },
  };
}

export default connect(mapStateToProps)(SchoolApplicationSettingsForm);
